export interface Item {
  name: string;
  countryCode: string;
  province: string | string[];
  idTypes: string | string[];
}

export const countries = [
  {
    name: 'Nigeria',
    countryCode: 'NG',
    province: '',
    // idTypes: ['Id Card', 'Passport', 'Drivers License', 'Voter Id'],
  },
] as const;
// export const countries = [
//   {
//     name: 'Afghanistan',
//     countryCode: 'AF',
//     province: '',
//     idTypes: ['Id Card', 'Passport'],
//   },
//   {
//     name: 'Albania',
//     countryCode: 'AL',
//     province: '',
//     idTypes: [
//       'Drivers License',
//       'Driver Card',
//       'Id Card',
//       'Professional DL',
//       'Passport',
//     ],
//   },
//   {
//     name: 'Algeria',
//     countryCode: 'DZ',
//     province: '',
//     idTypes: ['Id Card', 'passport', 'Drivers License'],
//   },
//   {
//     name: 'Armenia',
//     countryCode: 'AM',
//     province: '',
//     idTypes: ['Id Card', 'passport', 'Drivers License'],
//   },
//   // {
//   //   name: 'Antigua & Barbuda',
//   //   countryCode: '',
//   //   province: '',
//   //   idTypes: ['Drivers License'],
//   // },
//   {
//     name: 'Argentina',
//     countryCode: 'AR',
//     province: '',
//     idTypes: ['Alien Id', 'Id Card', 'passport', 'Drivers License'],
//   },
//   {
//     name: 'Australia',
//     countryCode: 'AU',
//     province: '',
//     idTypes: ['Passport'],
//   },
//   {
//     name: 'Australia',
//     countryCode: 'AU',
//     province: 'New South Wales',
//     idTypes: ['Drivers License', 'Id Card', 'Passport'],
//   },
//   {
//     name: 'Australia',
//     countryCode: 'AU',
//     province: 'South Australia, Northern Territory, Queensland',
//     idTypes: ['Drivers License', 'Passport', 'Proof of Age Card'],
//   },
//   {
//     name: 'Australia',
//     countryCode: 'AU',
//     province:
//       'Tasmania, Victoria, Western Australia, Queensland, Australian Capital Territory',
//     idTypes: ['Drivers License', 'Passport'],
//   },
//   {
//     name: 'Austria',
//     countryCode: 'AT',
//     province: '',
//     idTypes: ['Passport', 'Id Card', 'Passport', 'Residence Permit'],
//   },
//   {
//     name: 'Azerbaijan',
//     countryCode: 'AZ',
//     province: '',
//     idTypes: ['Passport', 'Id Card'],
//   },
//   {
//     name: 'Bahamas',
//     countryCode: 'BS',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License'],
//   },
//   {
//     name: 'Bahrain',
//     countryCode: 'BH',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'Bangladesh',
//     countryCode: 'BD',
//     province: '',
//     idTypes: ['Id Card', 'passport', 'Drivers License'],
//   },
//   {
//     name: 'Belarus',
//     countryCode: 'BY',
//     province: '',
//     idTypes: ['Passport', 'Drivers License'],
//   },
//   {
//     name: 'Belgium',
//     countryCode: 'BE',
//     province: '',
//     idTypes: [
//       'Passport',
//       'Id Card',
//       'Passport',
//       'Residence Permit',
//       'Resident Id',
//       'Drivers License',
//       'Minors Id',
//     ],
//   },
//   {
//     name: 'Bermuda',
//     countryCode: 'BM',
//     province: '',
//     idTypes: ['Drivers License'],
//   },
//   {
//     name: 'Bolivia',
//     countryCode: 'BO',
//     province: '',
//     idTypes: ['Drivers License', 'Minors Id', 'Id Card'],
//   },
//   {
//     name: 'Bosnia & Herzegovina',
//     countryCode: 'BA',
//     province: '',
//     idTypes: ['Id Card', 'passport', 'Drivers License'],
//   },
//   {
//     name: 'Botswana',
//     countryCode: 'BW',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'Brazil',
//     countryCode: 'BR',
//     province: 'Sao Paolo',
//     idTypes: [
//       'Id Card',
//       'passport',
//       'Drivers License',
//       'Consular Passport',
//       'Military Id',
//       'Residence Permit',
//       'Temporary Residence Permit',
//     ],
//   },
//   {
//     name: 'Brazil',
//     countryCode: 'BR',
//     province: '',
//     idTypes: [
//       'Id Card',
//       'passport',
//       'Drivers License',
//       'Consular Passport',
//       'Military Id',
//       'Residence Permit',
//       'Temporary Residence Permit',
//       'Id Card',
//       'Drivers License',
//       'Military Id',
//       'Residence Permit',
//       'Temporary Residence Permit',
//     ],
//   },
//   {
//     name: 'Brunei',
//     countryCode: 'BN',
//     province: '',
//     idTypes: [
//       'Id Card',
//       'Drivers License',
//       'Military Id',
//       'Residence Permit',
//       'Temporary Residence Permit',
//     ],
//   },
//   {
//     name: 'Bulgaria',
//     countryCode: 'BG',
//     province: '',
//     idTypes: ['Id Card', 'passport', 'Drivers License'],
//   },
//   {
//     name: 'Burkina Faso',
//     countryCode: 'BF',
//     province: '',
//     idTypes: ['Drivers License'],
//   },
//   {
//     name: 'Cambodia',
//     countryCode: 'KH',
//     province: '',
//     idTypes: ['Id Card', 'passport', 'Drivers License'],
//   },
//   {
//     name: 'Cameroon',
//     countryCode: 'CM',
//     province: '',
//     idTypes: ['Id Card'],
//   },

//   {
//     name: 'Canada',
//     countryCode: 'CA',
//     province: '',
//     idTypes: [
//       'Passport',
//       'Residence Permit',
//       'Social Security Card',
//       'Tribal Id',
//       'Weapon Permit',
//       'Citizenship Certificate',
//     ],
//   },
//   {
//     name: 'Canada',
//     countryCode: 'CA',
//     province: 'British Columbia',
//     idTypes: [
//       'Passport',
//       'Residence Permit',
//       'Social Security Card',
//       'Tribal Id',
//       'Weapon Permit',
//       'Drivers License',
//       'Id Card',
//       'Citizenship Certificate',
//       'Minors Public Services Card',
//       'Public Services Card',
//     ],
//   },
//   {
//     name: 'Canada',
//     countryCode: 'CA',
//     province: 'Manitoba, Alberta, Ontario, Nova Scotia, Saskatchewan',
//     idTypes: [
//       'Passport',
//       'Residence Permit',
//       'Social Security Card',
//       'Tribal Id',
//       'Weapon Permit',
//       'Drivers License',
//       'Citizenship Certificate',
//     ],
//   },
//   {
//     name: 'Canada',
//     countryCode: 'CA',
//     province: 'New Brunswick, Quebec, Newfoundland & Labradon, Yukon',
//     idTypes: [
//       'Passport',
//       'Residence Permit',
//       'Social Security Card',
//       'Tribal Id',
//       'Weapon Permit',
//       'Drivers License',
//       'Citizenship Certificate',
//     ],
//   },
//   {
//     name: 'Chile',
//     countryCode: 'CL',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License', 'Passport', 'Alien Id'],
//   },
//   {
//     name: 'China',
//     countryCode: 'CN',
//     province: '',
//     idTypes: ['Drivers License', 'Id Card'],
//   },
//   {
//     name: 'Colombia',
//     countryCode: 'CO',
//     province: '',
//     idTypes: [
//       'Drivers License',
//       'Id Card',
//       'Passport',
//       'Minors Id',
//       'Aliens Id',
//     ],
//   },
//   {
//     name: 'Costa Rica',
//     countryCode: 'CR',
//     province: '',
//     idTypes: ['Drivers License', 'Id Card'],
//   },
//   {
//     name: 'Croatia',
//     countryCode: 'HR',
//     province: '',
//     idTypes: ['Id Card', 'passport', 'Drivers License', 'Residence Permit'],
//   },
//   // {
//   //   name: 'Cuba',
//   //   countryCode: '--',
//   //   province: '',
//   //   idTypes: ['Passport'],
//   // },
//   {
//     name: 'Cyprus',
//     countryCode: 'CY',
//     province: '',
//     idTypes: ['Id Card', 'passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Czechia',
//     countryCode: 'CZ',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Democratic Republic Of The Congo',
//     countryCode: 'CD',
//     province: '',
//     idTypes: ['Drivers License'],
//   },
//   {
//     name: 'Denmark',
//     countryCode: 'DK',
//     province: '',
//     idTypes: ['Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Dominican Republic',
//     countryCode: 'DO',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Ecuador',
//     countryCode: 'EC',
//     province: '',
//     idTypes: ['Drivers License', 'Id Card'],
//   },
//   {
//     name: 'Egypt',
//     countryCode: 'EG',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'El Salvador',
//     countryCode: 'SV',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License'],
//   },
//   {
//     name: 'Estonia',
//     countryCode: 'EE',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Alien ID'],
//   },
//   {
//     name: 'Eswatini',
//     countryCode: 'SZ',
//     province: '',
//     idTypes: ['Passport'],
//   },
//   {
//     name: 'Finland',
//     countryCode: 'FI',
//     province: '',
//     idTypes: [
//       'Drivers License',
//       'Id Card',
//       'Passport',
//       'Residence Permit',
//       'Aliens Id',
//     ],
//   },
//   {
//     name: 'France',
//     countryCode: 'FR',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Georgia',
//     countryCode: 'GE',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Germany',
//     countryCode: 'DE',
//     province: '',
//     idTypes: [
//       'Id Card',
//       'Passport',
//       'Drivers License',
//       'Residence Permit',
//       'Minors Passport',
//     ],
//   },
//   {
//     name: 'Ghana',
//     countryCode: 'GH',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Greece',
//     countryCode: 'GR',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Guatemala',
//     countryCode: 'GT',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Consular Id'],
//   },
//   {
//     name: 'Haiti',
//     countryCode: 'HT',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Honduras',
//     countryCode: 'HN',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Hong Kong',
//     countryCode: 'HK',
//     province: '',
//     idTypes: ['Id Card', 'Passport'],
//   },
//   {
//     name: 'Hungary',
//     countryCode: 'HU',
//     province: '',
//     idTypes: [
//       'Id Card',
//       'Passport',
//       'Drivers License',
//       'Residence Permit',
//       'Address Card',
//     ],
//   },
//   {
//     name: 'Iceland',
//     countryCode: 'IS',
//     province: '',
//     idTypes: ['Passport', 'Drivers License'],
//   },
//   {
//     name: 'India',
//     countryCode: 'IN',
//     province: '',
//     idTypes: ['Pan Card', 'Id Card', 'Passport', 'Voter Id'],
//   },
//   {
//     name: 'India',
//     countryCode: 'IN',
//     province:
//       'Gujarat, Karnataka, Punjab, Madhya Pradesh, Maharashtra, Kerala, Tamil Nadu',
//     idTypes: [
//       'Pan Card',
//       'Id Card',
//       'Passport',
//       'Voter Id',
//       'Drivers License',
//       'Voter Id',
//       'Drivers License',
//     ],
//   },
//   {
//     name: 'Indonesia',
//     countryCode: 'ID',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Iran',
//     countryCode: 'IR',
//     province: '',
//     idTypes: ['Passport'],
//   },
//   {
//     name: 'Iraq',
//     countryCode: 'IQ',
//     province: '',
//     idTypes: ['Passport', 'Id Card'],
//   },
//   {
//     name: 'Ireland',
//     countryCode: 'IE',
//     province: '',
//     idTypes: [
//       'Passport Card',
//       'Drivers License',
//       'Public Services Card',
//       'Passport',
//     ],
//   },
//   {
//     name: 'Israel',
//     countryCode: 'IL',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Italy',
//     countryCode: 'IT',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Ivory Coast',
//     countryCode: 'CI',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License'],
//   },
//   {
//     name: 'Jamaica',
//     countryCode: 'JM',
//     province: '',
//     idTypes: ['Drivers License'],
//   },
//   {
//     name: 'Japan',
//     countryCode: 'JP',
//     province: '',
//     idTypes: ['My Number Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Jordan',
//     countryCode: 'JO',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Kazakhstan',
//     countryCode: 'KZ',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'Kenya',
//     countryCode: 'KE',
//     province: '',
//     idTypes: ['Id Card', 'Passport'],
//   },
//   {
//     name: 'Kosovo',
//     countryCode: 'XK',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Kuwait',
//     countryCode: 'KW',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Kyrgyzstan',
//     countryCode: 'KG',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'Latvia',
//     countryCode: 'LV',
//     province: '',
//     idTypes: [
//       'Passport',
//       'Id Card',
//       'Alien Id',
//       'Residence Permit',
//       'Alien Passport',
//       'Drivers License',
//     ],
//   },
//   {
//     name: 'Lebanon',
//     countryCode: 'LB',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'Libya',
//     countryCode: 'LY',
//     province: '',
//     idTypes: ['Passport'],
//   },
//   {
//     name: 'Lithuania',
//     countryCode: 'LT',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Luxembourg',
//     countryCode: 'LU',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Malaysia',
//     countryCode: 'MY',
//     province: '',
//     idTypes: [
//       'My KAS',
//       'MyKad',
//       'Drivers License',
//       'MyKid',
//       'MyPolis',
//       'MyTentera',
//       'i-Kad',
//       'Refugee ID',
//       'Passport',
//       'MyPR',
//     ],
//   },
//   {
//     name: 'Maldives',
//     countryCode: 'MV',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'Malta',
//     countryCode: 'MT',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Mauritius',
//     countryCode: 'MU',
//     province: '',
//     idTypes: ['Id Card'],
//   },

//   {
//     name: 'Mexico',
//     countryCode: 'MX',
//     province: '',
//     idTypes: [
//       'Consular Id',
//       'Professional DL',
//       'Professional ID',
//       'Voter Id',
//       'Passport',
//       'Resident Permit',
//     ],
//   },
//   {
//     name: 'Mexico',
//     countryCode: 'MX',
//     province:
//       'Baja California Sur, Campeche, Baja California, Chiapas, Chihuahua, Ciudad de Mexico, Coahuila, Colima, Durango, Guanajuato, Guerrero-Cocula, Guerrero-Juchitan, Hidalgo, Jalisco, Mexico, Michoacan, Michoacan, Morelos, Nayarit, Nuevo Leon, Oaxaca, Puebla, Quintana Roo-Cozumel, Yucatan, Quintana Roo-Solidaridad, San Luis Potosi, Sonora, Sinaloa, Tabasco, Tamaulipas, Tlaxcala, Veracruz, Zacatecas',
//     idTypes: [
//       'Consular Id',
//       'Professional DL',
//       'Professional ID',
//       'Voter Id',
//       'Passport',
//       'Resident Permit',
//       'Drivers License',
//     ],
//   },
//   {
//     name: 'Moldova',
//     countryCode: 'MD',
//     province: '',
//     idTypes: ['Passport', 'Id Card'],
//   },
//   {
//     name: 'Montenegro',
//     countryCode: 'ME',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Morocco',
//     countryCode: 'MA',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Mozambique',
//     countryCode: 'MZ',
//     province: '',
//     idTypes: ['Drivers License'],
//   },
//   {
//     name: 'Myanmar',
//     countryCode: 'MM',
//     province: '',
//     idTypes: ['Drivers License'],
//   },
//   {
//     name: 'Nepal',
//     countryCode: 'NP',
//     province: '',
//     idTypes: ['Passport'],
//   },
//   {
//     name: 'Netherlands',
//     countryCode: 'NL',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'New Zealand',
//     countryCode: 'NZ',
//     province: '',
//     idTypes: ['Passport', 'Drivers License'],
//   },
//   {
//     name: 'Nicaragua',
//     countryCode: 'NI',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'Nigeria',
//     countryCode: 'NG',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Voter Id'],
//   },
//   {
//     name: 'North Macedonia',
//     countryCode: 'MK',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Norway',
//     countryCode: 'NO',
//     province: '',
//     idTypes: ['Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Oman',
//     countryCode: 'OM',
//     province: '',
//     idTypes: ['Id Card', 'Resident Id', 'Drivers License'],
//   },
//   {
//     name: 'Pakistan',
//     countryCode: 'PK',
//     province: '',
//     idTypes: ['Passport', 'Consular Id', 'Id Card'],
//   },
//   {
//     name: 'Pakistan',
//     countryCode: 'PK',
//     province: 'Punjab',
//     idTypes: ['Passport', 'Consular Id', 'Id Card', 'Drivers License'],
//   },
//   {
//     name: 'Panama',
//     countryCode: 'PA',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License'],
//   },
//   {
//     name: 'Paraguay',
//     countryCode: 'PY',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License'],
//   },
//   {
//     name: 'Peru',
//     countryCode: 'PE',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Minors Id'],
//   },
//   {
//     name: 'Philippines',
//     countryCode: 'PH',
//     province: '',
//     idTypes: [
//       'Id Card',
//       'Drivers License',
//       'Passport',
//       'Residence Permit',
//       'Tax Id',
//       'Voter Id',
//       'Social Security Card',
//       'Professional Id',
//       'Multipurpose Id',
//     ],
//   },
//   {
//     name: 'Poland',
//     countryCode: 'PL',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Portugal',
//     countryCode: 'PT',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Puerto Rico',
//     countryCode: 'PR',
//     province: '',
//     idTypes: ['Drivers License', 'Voter Id'],
//   },
//   {
//     name: 'Qatar',
//     countryCode: 'QA',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Romania',
//     countryCode: 'RO',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Russia',
//     countryCode: 'RU',
//     province: '',
//     idTypes: ['Passport', 'Drivers License'],
//   },
//   {
//     name: 'Rwanda',
//     countryCode: 'RW',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'Saudi Arabia',
//     countryCode: 'SA',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Id'],
//   },
//   {
//     name: 'Senegal',
//     countryCode: 'SN',
//     province: '',
//     idTypes: ['Id Card'],
//   },

//   {
//     name: 'Serbia',
//     countryCode: 'RS',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Singapore',
//     countryCode: 'SG',
//     province: '',
//     idTypes: [
//       'Id Card',
//       'Drivers License',
//       'Passport',
//       'Residence Id',
//       'Employment Pass',
//       'Fin Card',
//       'S Pass',
//       'Work Permit',
//     ],
//   },
//   {
//     name: 'Slovakia',
//     countryCode: 'SK',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Id'],
//   },
//   {
//     name: 'Slovenia',
//     countryCode: 'SI',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'South Africa',
//     countryCode: 'ZA',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'South Korea',
//     countryCode: 'KR',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Spain',
//     countryCode: 'ES',
//     province: '',
//     idTypes: [
//       'Id Card',
//       'Passport',
//       'Drivers License',
//       'Residence Permit',
//       'Alien Id',
//     ],
//   },
//   {
//     name: 'Sri Lanka',
//     countryCode: 'LK',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Sudan',
//     countryCode: 'SD',
//     province: '',
//     idTypes: ['Passport'],
//   },
//   {
//     name: 'Sweden',
//     countryCode: 'SE',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Alien ID'],
//   },
//   {
//     name: 'Switzerland',
//     countryCode: 'CH',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'Syria',
//     countryCode: 'SY',
//     province: '',
//     idTypes: ['Passport'],
//   },
//   {
//     name: 'Taiwan',
//     countryCode: 'TW',
//     province: '',
//     idTypes: ['Passport', 'Temporary Residence Permit'],
//   },
//   {
//     name: 'Tajikistan',
//     countryCode: 'TJ',
//     province: '',
//     idTypes: ['Passport'],
//   },
//   {
//     name: 'Tanzania',
//     countryCode: 'TZ',
//     province: '',
//     idTypes: ['Id Card', 'Voter Id', 'Drivers License'],
//   },
//   {
//     name: 'Thailand',
//     countryCode: 'TH',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Alien ID'],
//   },
//   {
//     name: 'Trinidad And Tobago',
//     countryCode: 'TT',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License'],
//   },
//   {
//     name: 'Tunisia',
//     countryCode: 'TN',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License'],
//   },
//   {
//     name: 'Turkey',
//     countryCode: 'TR',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Permit'],
//   },
//   {
//     name: 'UAE',
//     countryCode: 'AE',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Drivers License', 'Residence Id'],
//   },
//   {
//     name: 'Uganda',
//     countryCode: 'UG',
//     province: '',
//     idTypes: ['Id Card', 'Drivers License'],
//   },
//   {
//     name: 'UK',
//     countryCode: 'GB',
//     province: '',
//     idTypes: ['Id Card', 'Passport', 'Residence Id', 'Proof Of Age Card'],
//   },
//   {
//     name: 'Ukraine',
//     countryCode: 'UA',
//     province: '',
//     idTypes: [
//       'Id Card',
//       'Drivers License',
//       'Passport',
//       'Residence Permit',
//       'Temporary Residence Permit',
//     ],
//   },
//   {
//     name: 'Uruguay',
//     countryCode: 'UG',
//     province: '',
//     idTypes: ['Id Card'],
//   },
//   {
//     name: 'USA',
//     countryCode: 'US',
//     province: '',
//     idTypes: [
//       'Border Crossing Card',
//       'Global Entry Card',
//       'Green Card',
//       'Military ID',
//       'Nexus Card',
//       'Passport Card',
//       'Passport',
//       'Social Security Card',
//       'Veteran ID',
//       'Work Permit',
//     ],
//   },
//   {
//     name: 'USA',
//     countryCode: 'US',
//     province:
//       'Delaware, Louisiana, New Hampshire, South Dakota , West Virginia, Wyoming',
//     idTypes: [
//       'Border Crossing Card',
//       'Global Entry Card',
//       'Green Card',
//       'Military ID',
//       'Nexus Card',
//       'Passport Card',
//       'Passport',
//       'Social Security Card',
//       'Veteran ID',
//       'Work Permit',
//       'Drivers License',
//     ],
//   },
//   {
//     name: 'USA',
//     countryCode: 'US',
//     province:
//       'District Of Columbia, Florida, Georgia, Hawaii, Idaho, Iowa Illinois, Indiana, Kansas Kentucky, Maine, Maryland Massachusetts, Michigan Minnesota, Mississippi, Utah Missouri, Montana, Nebraska Nevada,New Jersey, New Mexico, New York, North Carolina, Ohio Oklahoma, Oregon, Pennsylvania Rhode Island, South Carolina, Tennessee, Vermont, Virginia, Washington, Wisconsin, Alabama Alaska, Arizona, Arkansas, California, Colorado',
//     idTypes: [
//       'Border Crossing Card',
//       'Global Entry Card',
//       'Green Card',
//       'Military ID',
//       'Nexus Card',
//       'Passport Card',
//       'Passport',
//       'Social Security Card',
//       'Veteran ID',
//       'Work Permit',
//       'Drivers Lincense',
//       'Id Card',
//     ],
//   },
//   {
//     name: 'USA',
//     countryCode: 'US',
//     province: 'New York City',
//     idTypes: [
//       'Border Crossing Card',
//       'Global Entry Card',
//       'Green Card',
//       'Military ID',
//       'Nexus Card',
//       'Passport Card',
//       'Passport',
//       'Social Security Card',
//       'Veteran ID',
//       'Work Permit',
//       'Id Card',
//     ],
//   },
//   {
//     name: 'USA',
//     countryCode: 'US',
//     province: 'Texas',
//     idTypes: [
//       'Border Crossing Card',
//       'Global Entry Card',
//       'Green Card',
//       'Military ID',
//       'Nexus Card',
//       'Passport Card',
//       'Passport',
//       'Social Security Card',
//       'Veteran ID',
//       'Work Permit',
//       'Drivers License',
//       'Id Card',
//       'Weapon Permit',
//     ],
//   },
//   {
//     name: 'Uzbekistan',
//     countryCode: 'UZ',
//     province: '',
//     idTypes: ['Drivers License', 'Passport'],
//   },
//   {
//     name: 'Venezuela',
//     countryCode: 'VE',
//     province: '',
//     idTypes: ['Drivers License', 'Passport', 'Id Card'],
//   },
//   {
//     name: 'Vietnam',
//     countryCode: 'VN',
//     province: '',
//     idTypes: ['Drivers License', 'Id Card'],
//   },
//   {
//     name: 'Zimbabwe',
//     countryCode: 'ZW',
//     province: '',
//     idTypes: ['Passport'],
//   },
// ] as const;
